import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {Device} from "../device";
import {DeviceOptions} from "./redemption-options";

@Component({
	selector: "device-options",
	template: `
		<div *ngIf="showDeviceRow" class="deviceoptions_devicerow">
			<div class="deviceoptions_device">
				<image-container *ngIf="deviceOptions.device"
					[width]="50"
					[height]="50"
					[src]="deviceOptions.deviceModel.imageURL"
					[alt]="deviceOptions.deviceModel.displayName"></image-container>
				<div class="deviceoptions_deviceinfo">
					<div class="deviceoptions_devicename">
						{{deviceOptions.device.name}}
					</div>
					<div *ngIf="deviceOptions.deviceModel; let model" class="deviceoptions_devicedetails">
						{{model.make}} {{model.name}} - {{deviceOptions.device.displaySerial}}
					</div>
				</div>
			</div>
			<div *ngIf="isPortable" class="deviceoptions_changebutton">
				<button type="button" class="button button-secondary" (click)="changePortable()">
					Change Portable
				</button>
			</div>
		</div>

		<div [formGroup]="deviceSelectionForm" class="deviceoptions_formgroup">
			<div formArrayName="groupSelection">
				<div *ngFor="let selection of groupSelection.controls; let i = index;" [formGroupName]="i">
					<group-options *ngIf="showGroupOptions(i)"
						[selectionForm]="selection"
						[controlID]="controlID(i)"
						[options]="deviceOptions.deviceModelAvdbTypes[i]"
						[couponCode]="couponCode">
					</group-options>
				</div>
			</div>

			<ng-container *ngIf="showExpandButton">
				<a class="deviceoptions_expandbutton" (click)="showAllGroupOptions = !showAllGroupOptions">
				<i class="{{(showAllGroupOptions) ? 'fa fa-caret-up' : 'fa fa-caret-down'}}"></i>
					{{expandButtonText}}
				</a>
			</ng-container>
		</div>
	`,
})

export class DeviceOptionsComponent {
	@Input() deviceSelectionForm: FormGroup;
	@Input() deviceOptions: DeviceOptions;
	@Input() portableList: Array<number>;
	@Input() couponCode: string;
	@Output() portableChange: EventEmitter<Device> = new EventEmitter();
	showAllGroupOptions = false;

	controlID(index: number) {
		return `${this.deviceOptions.device.id}_${index}`;
	}

	get groupSelection(): FormArray {
		return this.deviceSelectionForm.get("groupSelection") as FormArray;
	}
	get showDeviceRow(): boolean {
		return this.deviceOptions.groupType === "avdbType";
	}

	get isPortable(): boolean {
		return this.portableList && this.portableList.includes(this.deviceOptions.device.id);
	}

	get showExpandButton(): boolean {
		return this.deviceOptions.groupType !== "device" && this.numRequiredSelections() !== this.numAllSelections();
	}

	get expandButtonText(): string {
		if (this.showAllGroupOptions) {
			return `Show Required Selections (${this.numRequiredSelections()})`;
		}
		else {
			return `Show All Databases (${this.numAllSelections()})`;
		}
	}

	private numRequiredSelections(): number {
		return this.deviceOptions.deviceModelAvdbTypes.filter(options => options.productOptions.length > 1).length;
	}

	private numAllSelections(): number {
		return this.deviceOptions.deviceModelAvdbTypes.length;
	}

	// Determines if the groups expand automatically, based on whether there's a user selection to be made.
	showGroupOptions(index: number): boolean {
		return this.showAllGroupOptions || this.deviceOptions.deviceModelAvdbTypes[index].productOptions.length > 1 || this.deviceOptions.deviceModelAvdbTypes[index].groupType === 'device';
	}

	changePortable() {
		this.portableChange.emit(this.deviceOptions.device);
	}
}
